import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { doMainMenuToggle } from "../redux/reducers";

import MainMenu from "../menu/MainMenu";
import Header from "../headers/Header";
import Book from "../book/Book";

const AppContainer = styled.div``;

const AppWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: ${props => props.theme.colors.primaryDark};
  display: flex;
`;

const MainPanel = styled.div`
  width: 100%;
  height: 100%;
  z-index: 1;
`;
class Application extends Component {
  render() {
    const { onMainMenuToggle, isMenuOpen } = this.props;

    return (
      <AppContainer>
        <AppWrapper>
          <MainMenu
            onMainMenuToggle={onMainMenuToggle}
            isMenuOpen={isMenuOpen}
          />
          <MainPanel>
            <Header
              onMainMenuToggle={onMainMenuToggle}
              isMenuOpen={isMenuOpen}
            />
            <Book />
          </MainPanel>
        </AppWrapper>
      </AppContainer>
    );
  }
}

const mapStateToProps = state => ({
  isMenuOpen: state.appState.mainMenu.open
});

const mapDispatchToProps = dispatch => ({
  onMainMenuToggle: () => dispatch(doMainMenuToggle())
});

export default connect(mapStateToProps, mapDispatchToProps)(Application);



// WEBPACK FOOTER //
// ./src/application/Application.js